import { rem } from 'polished'
import styled from 'styled-components'

import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import LuxuryEscapesTripPlannerLogoRebrand from 'components/App/Header/Logo/rebrand-logos/LuxuryEscapesTripPlannerLogoRebrand'
import Clickable from 'components/Common/Clickable'
import NavBarButtonBase from 'components/NavKit/NavBarButton/NavBarButtonBase'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import zIndex from 'styles/tools/z-index'
import { headerHeight } from 'tripPlanner/config'

export const TripPlannerHeaderIconButton = styled(NavBarButtonBase)`
  width: ${rem(38)};
  height: ${rem(38)};
  padding: 0;
  border: 0;
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

export const TripPlannerStickyHeader = styled.header`
  position: sticky;
  top: 0;
  inset-inline: 0;
  height: ${headerHeight.sm};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  z-index: ${zIndex.stickyHeader};
  padding: 0 ${rem(16)};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.withShadow {
    box-shadow: ${props => props.theme.shadow.bottom.small};
  }

  ${mediaQueryUp.desktop} {
    height: ${headerHeight.lg};
  }

  @media print {
    display: none;
  }
`

export const TripPlannerHeaderCentreContent = styled(Clickable)`
  position: absolute;
  inset-inline-start: 50%;
  transform: translateX(-50%);

  &:not(:disabled) {
    &:hover {
      background-color: unset;
      border-color: transparent;
      color: unset;
    }
  }

  [dir='rtl'] & {
    transform: translateX(50%);
  }
`

export const TripPlannerStyledLogo = styled(LuxuryEscapesSmallLogo)`
  width: ${rem(36)};
  height: ${rem(36)};
`

// Figma sizes the lockup 26px tall on mobile and 30px on desktop; 28px keeps it beside the collapse button in the 256px side nav.
export const TripPlannerLockupLogo = styled(LuxuryEscapesTripPlannerLogoRebrand)`
  display: block;
  block-size: ${rem(26)};
  inline-size: auto;

  ${mediaQueryUp.desktop} {
    block-size: ${rem(28)};
  }
`

export const LeftContent = styled.div`
  justify-self: flex-start;
  display: flex;
  flex-shrink: 1;
  min-width: ${rem(48)};
  align-items: center;
  gap: ${rem(8)};
`

export const RightContent = styled.div`
  justify-self: flex-end;
  display: flex;
  align-items: center;

  gap: ${rem(8)};
  margin-inline-start: ${rem(16)};
`

export const FlexBreakpoint = styled(CSSBreakpoint)`
  display: flex;
  align-items: center;
`
